import clsx from "clsx";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { slides } from "../constants";

export default function CarouselComponent() {
  const [current, setCurrent] = useState(0);

  const nextSlide = () => setCurrent((prev) => (prev + 1) % slides.length);

  const prevSlide = () =>
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);

  return (
    <div className={parentContainer}>
      <AnimatePresence mode="wait">
        <motion.div
          key={current}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 0.1 }}
          className="flex flex-col"
        >
          <img
            src={slides[current].image}
            alt={`Slide ${current + 1}`}
            className={imgStyle}
          />
          <p className={captionStyle}>{slides[current].caption}</p>
        </motion.div>
      </AnimatePresence>

      <div className={arrowContainer}>
        <div className="hover:text-creme" onClick={prevSlide}>
          -_
        </div>
        <div className="hover:text-creme" onClick={nextSlide}>
          _-
        </div>
      </div>
    </div>
  );
}

const parentContainer = clsx(
  "relative w-full overflow-hidden mb-4 lg:mb-0 max-w-screen"
);
const arrowContainer = clsx(
  "absolute top-1/2 text-4xl cursor-pointer inset-x-0 flex text-creme/60 justify-between px-4 transform -translate-y-1/2"
);
const imgStyle = clsx(
  "object-cover w-full h-[240px] sm:h-[400px] md:h-[650px]"
);
const captionStyle = clsx(
  "mt-2 text-center lg:text-right text-black/40 text-[10px]"
);
